jQuery(".pf-option-swatches .pf-vs-radio").each(function () {
  var color = jQuery(this).find("input").attr("value");
  jQuery(this).find("label").css("background", color);
});

jQuery(window).scroll(function () {
  if (jQuery(window).scrollTop() > 150) {
    jQuery(".back_to_top").addClass("active");
  } else {
    jQuery(".back_to_top").removeClass("active");
  }

  if (jQuery(".fixedbar-cust").length > 0) {
    var top_pos = jQuery(".faq_banner_product ").offset().top;
    var sroller_page = jQuery(window).scrollTop();

    if (sroller_page >= top_pos) {
      jQuery(".fixedbar-cust").addClass("active");
    } else {
      jQuery(".fixedbar-cust").removeClass("active");
    }
  }

  jQuery(".add-btn").on("click", function (e) {
    var form = jQuery("#addToCart");
    e.preventDefault();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: form.serialize(),
      success: function (data) {
        form.find('input[name="checkout"]').trigger("click");
      },
    });
  });
});

setTimeout(function () {
  jQuery(".social-share-section").appendTo(".shar_clone");
}, 1000);

jQuery(".back_to_top").click(function () {
  jQuery("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});

// clone content
jQuery(".left_side_contenet_copy").each(function () {
  jQuery(".left_side_contenet").clone().appendTo(this);
  jQuery(this).find(".left_side_contenet").removeClass("sticky_Div");
});

jQuery("#777C87_residential").click(function () {
  updateURL("use", "residential");
  jQuery("#dark_gray_residential").show();
  jQuery("#dark_gray_commorcial").hide();
  jQuery("#light_gray_residential").hide();
  jQuery("#light_gray_commorcial").hide();
});

jQuery("#777C87_commercial").click(function () {
  //alert("in");
  updateURL("use", "commercial");
  jQuery("#dark_gray_commorcial").show();
  jQuery("#dark_gray_residential").hide();
  jQuery("#light_gray_residential").hide();
  jQuery("#light_gray_commorcial").hide();
});

jQuery("#ffffff_residential").click(function () {
  updateURL("use", "residential");
  jQuery("#dark_gray_residential").hide();
  jQuery("#dark_gray_commorcial").hide();
  jQuery("#light_gray_residential").show();
  jQuery("#light_gray_commorcial").hide();
});
jQuery("#ffffff_commercial").click(function () {
  updateURL("use", "commercial");
  jQuery("#dark_gray_commorcial").hide();
  jQuery("#dark_gray_residential").hide();
  jQuery("#light_gray_residential").hide();
  jQuery("#light_gray_commorcial").show();
});

function updateVariant(color) {
  for (let i = 0; i < window.BoosterApps.common.product.variants.length; i++) {
    if (window.BoosterApps.common.product.variants[i].title == color) {
      updateURL("variant", window.BoosterApps.common.product.variants[i].id);
    }
    /*else if(window.BoosterApps.common.product.variants[i].title == "#777C87"){
       updateURL("variant",window.BoosterApps.common.product.variants[i].id);
    }*/
  }
}

jQuery(".pf-option-swatches .pf-vs-radio").click(function () {
  var color_new = jQuery(this).find("input").attr("value");

  if (color_new == "#ffffff") {
    //updateVariant(color_new);
    showLight();

    $("#gray_color").find("[data-pf-tab-active=true]").trigger("click");
  } else if (color_new == "#777C87") {
    //updateVariant(color_new);
    showDark();
    $("#dark_color").find("[data-pf-tab-active=true]").trigger("click");
  }
});

function showLight() {
  jQuery("#gray_color").show();
  jQuery("#dark_color").hide();

  jQuery("#gray_color_video").show();
  jQuery("#dark_color_video").hide();

  jQuery("#light_gray_residential").show();
  jQuery("#light_gray_commorcial").hide();
  jQuery("#dark_gray_commorcial").hide();
  jQuery("#dark_gray_residential").hide();
}

function showDark() {
  jQuery("#gray_color").hide();
  jQuery("#dark_color").show();

  jQuery("#gray_color_video").hide();
  jQuery("#dark_color_video").show();

  jQuery("#light_gray_residential").hide();
  jQuery("#light_gray_commorcial").hide();
  jQuery("#dark_gray_commorcial").hide();
  jQuery("#dark_gray_residential").show();
}

function updateURL(key, value) {
  // Construct URLSearchParams object instance from current URL querystring.
  var queryParams = new URLSearchParams(window.location.search);

  // Set new or modify existing parameter value.
  queryParams.set(key, value);

  history.pushState(null, null, "?" + queryParams.toString());
}

function videmore() {
  jQuery(".range_showcase_wrapper").addClass("load_all");
  jQuery("#hiddedn_onclick").hide();
}

jQuery(document).ready(function () {
  // equalheight(".testimonial");
  //   equalheight('.product_testimonial  .testimonial');
  //   equalheight('.press_carousel  .testimonial');
  // equalheight('.recognize_carousel  .testimonial');
  // // sticky mobile bar js
  $(".surround_iadd").click(function () {
    $(".pf-1515_").click();
  });

  $(".surround_i").click(function () {
    $(".pf-1518_").click();
  });

  $(".surroundadd").click(function () {
    $(".pf-45_").click();
  });

  $(".surroundck").click(function () {
    $(".pf-48_").click();
  });

  //console.log("Button Event Working");
  $(".stkyaddcart").click(function () {
    $(".product-form--atc-button").click();
  });

  // $('.stkybuynow').click(function(){
  //   $('.shopify-payment-button__button').click();
  // });

  jQuery(".pf-option-swatches input").each(function () {
    //alert(jQuery(this).attr('checked'))

    if (jQuery(this).attr("checked") == "checked") {
      let colCode = "";
      if (jQuery(this).attr("value") == "#ffffff") {
        showLight();
        colCode = "ffffff";
        $("#gray_color").find("[data-pf-tab-active=true]").trigger("click");
      } else if (jQuery(this).attr("value") == "#777C87") {
        showDark();
        colCode = "777C87";
        $("#dark_color").find("[data-pf-tab-active=true]").trigger("click");
      }

      const params = new Proxy(new URLSearchParams(window.location.href), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      setTimeout(function () {
        jQuery("#" + colCode + "_" + params.use).trigger("click");
      }, 2000);
    }
  });
  // equalheight(".testimonial");
  // equalheight(".featured-collection__content .productitem--title a");

  jQuery(".gide-view-btn").click(function () {
    jQuery(".gide-view").show();
    jQuery(".listview").hide();
    jQuery(".view_icons").removeClass("active");
    jQuery(this).addClass("active");
  });

  jQuery(".list-view-btn").click(function () {
    jQuery(".listview").show();
    jQuery(".gide-view").hide();
    jQuery(".view_icons").removeClass("active");
    jQuery(this).addClass("active");
  });
});

/*
jQuery(window).resize(function(){
  equalheight(".testimonial");
  equalheight('.product_testimonial  .testimonial');
  equalheight('.press_carousel  .testimonial');
  equalheight('.recognize_carousel  .testimonial');

    equalheight(".featured-collection__content .productitem--title a");
});



jQuery(window).load(function() {
  setTimeout(function(){
    equalheight(".testimonial");
    equalheight('.product_testimonial  .testimonial');
    equalheight('.press_carousel  .testimonial');
  equalheight('.recognize_carousel  .testimonial');
  },500);


});





equalheight = function(container){

    var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
     jQuery(container).each(function() {

       $el = $(this);
      jQuery($el).height('auto')
       topPostion = $el.position().top;

       if (currentRowStart != topPostion) {
         for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].height(currentTallest);
         }
         rowDivs.length = 0; // empty the array
         currentRowStart = topPostion;
         currentTallest = $el.height();
         rowDivs.push($el);
       } else {
         rowDivs.push($el);
         currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
       for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }
 });
}
*/

//Whislist Icon Js
jQuery(".wishlist_icon_box").click(function () {
  jQuery(this).toggleClass("active");
});

// home video overlay image Js
jQuery(".vt_video_area").click(function () {
  jQuery(".vt_image_overlay").hide();
  jQuery("#vt_iframe")[0].src += "?rel=0&autoplay=1";
});

// jQuery('.underline .home-section--content .promo-grid--inner').slick({
//   infinite: true,
//   slidesToShow: 2,
//   slidesToScroll: 1
// });

setTimeout(function () {
  var url1 = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("utm_source=");
  var utmUrl = url1[1];
  //console.log(utmUrl);

  if (utmUrl == "Icubewire" || utmUrl == "icubewire" || utmUrl == "ICUBEWIRE") {
    //console.log('match');
    var my_awesome_script = document.createElement("script");
    my_awesome_script.setAttribute(
      "src",
      "https://retag.crossdevicetracking.com/universaltag.js"
    );
    document.head.appendChild(my_awesome_script);
    $("#addretag").html(
      "<script src=https://retag.crossdevicetracking.com/universaltag.js></script>"
    );
  } else {
    //console.log('another souce');
  }
}, 1000);

function getCookieValue(cookieName) {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName + "=") == 0) {
      return cookie.substring(cookieName.length + 1, cookie.length);
    }
  }

  return "";
}

var cookieValue = getCookieValue("utmSource");
if (
  cookieValue == "Icubewire" ||
  cookieValue == "icubewire" ||
  cookieValue == "ICUBEWIRE"
) {
  var my_awesome_script = document.createElement("script");
  my_awesome_script.setAttribute(
    "src",
    "https://retag.crossdevicetracking.com/universaltag.js"
  );
  document.head.appendChild(my_awesome_script);
  $("#addretag").html(
    "<script src=https://retag.crossdevicetracking.com/universaltag.js></script>"
  );
} else {
  // Handle the case where the cookie is not set
}

// About Counter Js
var counted = 0;
jQuery(window).scroll(function () {
  if (jQuery("#abt_counter").length) {
    var oTop = jQuery("#abt_counter").offset().top - window.innerHeight;
    if (counted == 0 && jQuery(window).scrollTop() > oTop) {
      jQuery(".count").each(function () {
        var jQuerythis = jQuery(this),
          countTo = jQuerythis.attr("data-count");
        jQuery({
          countNum: jQuerythis.text(),
        }).animate(
          {
            countNum: countTo,
          },

          {
            duration: 2000,
            easing: "swing",
            step: function () {
              jQuerythis.text(Math.floor(this.countNum));
            },
            complete: function () {
              jQuerythis.text(this.countNum);
              //alert('finished');
            },
          }
        );
      });
      counted = 1;
    }
  }
});

var win = $(window).width();
if (win > 1023) {
  var countdiv = $(".blog--inner").children(".article--excerpt-wrapper").length;
  if (countdiv == 2) {
    $(".blog--inner").css("justify-content", "flex-start");
    $(".blog--inner .article--excerpt-wrapper").css("margin-right", "40px");
  }
}

$(document).ready(function () {
  $(".list-view-btn").click();
});

// Surround page js
$("#radiogrey").click(function () {
  $(this).css("outline", "1px solid #0071BB");
  $("#radiowhite").css("outline", "none");
  $("#surround-static-product-form-0-variant-option-0-0").click();
});

$("#radiowhite").click(function () {
  $(this).css("outline", "1px solid #0071BB");
  $("#radiogrey").css("outline", "none");
  $("#surround-static-product-form-0-variant-option-0-1").click();
});

$("#surroundadd").click(function () {
  $(".product-form--atc-button").click();
});

$("#surroundbuy").click(function () {
  $(".shopify-payment-button__button").click();
});

$(".surround-btn").click(function () {
  $("#surroundadd").click();
});

$(".surround-btn-buy").click(function () {
  $("#surroundbuy").click();
});

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

$(".accordion__header").click(function (e) {
  e.preventDefault();
  var currentIsActive = $(this).hasClass("is-active");
  $(".accordion__body").slideUp();

  $(this).parent(".accordion").find("> *").removeClass("is-active");
  if (currentIsActive != 1) {
    $(this).addClass("is-active");
    $(this).next(".accordion__body").addClass("is-active");
    $(".accordion__body.is-active").slideDown();
  }
});

//   $(document).ready(function () {
//     var surround_slider_options = {
//       dots: true,
//       arrows:true,
//       prevArrow: '<button class="slide-arrow prev-arrow"></button>',
//       nextArrow: '<button class="slide-arrow next-arrow"></button>',
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1
//     };
//     //surround top banner slider
//     $('.surroundslider').slick(surround_slider_options);

//     $('.surroundslider-comm').slick(surround_slider_options);

//     //const $jq = jQuery.noConflict();

//     $('#defaultOpen').click(function(){
//       $('.surroundslider').slick('setPosition', 0);
//     });

//     $('#commtab').click(function(){
//       $('.surroundslider-comm').slick('setPosition', 0);
//     });
//   });

setTimeout(function () {
  $(
    ".site-mobile-nav a.navmenu-link.blink.mdc-ripple-surface.mdc-ripple-upgraded"
  ).css({
    color: "#0072BB",
    "font-weight": "bold",
    "font-size": "19px",
  });
}, 10);

!function ($) {
  $(document).ready(function () {
    setTimeout(function () {
      jQuery('.productgrid--item[data-id="6985443049529"]').css(
        "display",
        "none"
      );
      console.log("hide");
    }, 2000);

    $(".scroll-sec").click(function () {
      var sec_top = $("#" + $(this).attr("rel")).offset().top - 156;
      var scrollto = sec_top;
      $("html, body").animate({ scrollTop: scrollto }, 100);
    });

    $(".scroll-sec1").click(function () {
      var sec_top = $("#" + $(this).attr("rel")).offset().top + 50;
      var scrollto = sec_top;
      $("html, body").animate({ scrollTop: scrollto }, 100);
    });

    $(".navmenu-id-sale a").addClass("blink");

    // Flash Sale Js Start

    // Object containing multiple dates
    const dates = {
      event1: "June 5, 2025 12:00:00",
    };

    let lastEventExpiredTime = 0;
    let nextEventIndex = 0;

    function startNextEventCountdown() {
      if (nextEventIndex >= Object.keys(dates).length) {
        //console.log("All events have ended");
        $(".sale-link").css("display", "none");
        return;
      }
      const key = Object.keys(dates)[nextEventIndex];
      const eventDate = new Date(dates[key]).getTime();
      const now = new Date().getTime();
      const twoHoursInMilliseconds = 2 * 60 * 60 * 1000;
      const twoDaysInMilliseconds = 2 * 24 * 60 * 60 * 1000;

      if (now >= eventDate) {
        //console.log(key + " has already happened");
        if (now - eventDate > twoDaysInMilliseconds) {
          //console.log(now + "Now " + eventDate + "Test" + 2 * 60 * 60 * 1000 + "More than 2 hours have passed since the last event expired. Starting the next event countdown...");
          nextEventIndex++;
          setTimeout(startNextEventCountdown, 0);
        } else {
          //console.log("Sales have started for " + key);
          // $(".sale-link").css("display", "none");
          // $(".timmer-inner").html(
          //   "<div class='blink_text'>The Sale Is Started Click Here</div>"
          // );
          // $(".sale-link").attr(
          //   "href",
          //   "https://shop.symphonylimited.com/collections/tower-fans"
          // );
          $(".sale-link").css("display", "none");
          $(".announcement").css("display", "block");
          const elapsedTime = now - eventDate;
          //console.log("Elapsed time: " + elapsedTime + "ms");
        }
      } else {
        let timeRemaining = eventDate - now;
        setInterval(function () {
          timeRemaining = timeRemaining - 1000;

          if (timeRemaining < 0) {
            //console.log(key + " has expired");
            clearInterval(this);
            lastEventExpiredTime = new Date().getTime();
            //nextEventIndex++;
            setTimeout(startNextEventCountdown, 0);
          } else {
            var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
            var hours = Math.floor(
              (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.floor(
              (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            const elapsedTime = eventDate - (now + timeRemaining);
            //console.log(key + ": " + days + "d " + hours + "h " + minutes + "m " + seconds + "s " + "Elapsed time: " + elapsedTime + "ms");
            if(days < 10){
              days = "0" + days;
            }
            if(hours < 10){
              hours = "0" + hours;
            }
            if(minutes < 10){
              minutes = "0" + minutes;
            }
            if(seconds < 10){
              seconds = "0" + seconds;
            }
            //console.log(days, hours, minutes, seconds);
            $("#days").html(days + "<p>Days</p>");
            $("#hours").html(hours + "<p>Hrs</p>");
            $("#mins").html(minutes + "<p>Mins</p>");
            $("#secs").html(seconds + "<p>Secs</p>");
            $(".sale-link").css("display", "block");
            $(".announcement").css("display", "none");
          }
        }, 1000);
      }
    }

    startNextEventCountdown();
  });

  function blink_text() {
    $(".blink_text").fadeOut(500);
    $(".blink_text").fadeIn(500);
  }
  setInterval(blink_text, 1000);

  //  var countDownDate = new Date("Mar 15, 2023 23:59:59").getTime();

  //  var myfunc = setInterval(function() {

  //  var now = new Date().getTime();
  //  var timeleft = countDownDate - now;

  //  var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
  //  var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //  var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
  //  var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

  //  $('#days').html(days+ " Days ");
  //  $('#hours').html(hours + " Hrs ");
  //  $('#mins').html(minutes + " Mins ");
  //  $('#secs').html(seconds + " Secs ");

  // });

  $(document).ready(function () {
    // 21 Mar 2023 product out of stock changes

    $(".variants-ui__option-swatch-wrapper").click(function () {
      $(".variants-ui__option-value-input").prop("checked", false);
      $(this).closest(".variants-ui__option-value-input").prop("checked", true);
      //console.log("clicked vaiants");
      $(".variants-ui__option-swatch-wrapper").css("box-shadow", "unset");
      $(this).css("box-shadow", "0 0 0 1.5px #fff, 0 0 0 3px #818181");
    });

    // 25 Apr 2023 #SYMP-DEV-121 code start

    if (document.cookie.indexOf("popupshow=show") > -1) {
      document.getElementById("ac-wrapper").style.display = "none";
    } else {
      const currentUrl = window.location.href;
      if (currentUrl.endsWith("express-delivery")) {
        document.getElementById("ac-wrapper").style.display = "flex";
        $("body").css("overflow", "hidden");
      } else {
        $('#ac-wrapper').css('display', 'none');
        // document.getElementById("ac-wrapper").style.display = "none";
        $("body").css("overflow", "unset");
      }
    }

    // Express Collection Page
    var pincode =
      localStorage.myvalue && localStorage.myvalue != ""
        ? localStorage.myvalue
        : "400049";
    var total_avail = 0;
    $(".express-delivery-temp .productgrid--item").each(function (i, e) {
      var product = $(this).attr("data-sku");
      var product_idnt = e;
      //console.log(product);
      $(".count-product span").text(total_avail);
      if (product) {
        $.post(
          "https://symphony.myeshopbox.com/api/v2/check/product/serviceability",
          { dropPincode: pincode, productId: product }
        )
          .done(function (data) {
            //console.log(data.result.length);
            if (data.result.length > 0) {
              let res = data.result[0];
              if (data.result.length <= 1) {
                $(product_idnt).addClass("pro-notavaliable");
              } else {
                $(product_idnt).addClass("pro-avaliable");
                total_avail++;
                $(".count-product span").text(total_avail);
              }
            } else {
              //console.log("Error Pincode");
            }
          })
          .fail(function () {});
      }
    });
  });
  // Apr 13 SYMP-DEV-97 JS Start

  $(document).ready(function () {
    // home video overlay image Js
    jQuery(".vt_video_area").click(function () {
      jQuery(".vt_image_overlay").hide();
      jQuery("#vt_iframe")[0].src += "?rel=0&autoplay=1";
    });

    // Issue No 2
    var currentUrl = window.location.href;
    var hashValue = currentUrl.split("#")[1];
    //console.log(hashValue);
    if (hashValue) {
      $(".account-bottom .tab-cont .but").removeClass("active");
      $(".account-bottom .tab-content").css("display", "none");

      $(".account-bottom .tab-cont .but").each(function () {
        if ($(this).attr("data-number") === hashValue) {
          $(this).addClass("active");
        }
      });
      $(".account-bottom .tab-content").each(function () {
        if ($(this).attr("data-number") === hashValue) {
          $(this).css("display", "block");
        }
      });
    }

    // Issue No 3

    $(document).on("click", ".flits-product-card .flits-button", function (e) {
      $(".modal--quickshop-full .modal-close").click();
      var variantID;
      var product_url = $(this).siblings(".flits-product-image").attr("href");
      var product_handler = product_url.replace("/products/", "");
      $.getJSON(
        window.Shopify.routes.root + "products/" + product_handler + ".js",
        function (product) {
          if (product.variants.length > 0) {
            variantID = product.variants[0].id;
            // console.log('Variant ID: ' + variantID);
            let cart = {
              id: variantID,
              quantity: 1,
            };
            if (simply?.warrantyEnable) {
              simply.extendedWarrantyModal && simply.extendedWarrantyModal(cart, () => {
                $(".modal--quickshop-slim .modal-close").trigger("click");
                dropdowncart();
                $("#cart_drawer").addClass("active");
              });
              return false;
            }
            //console.log(cart);
            $.post("/cart/add.js", cart)
              .fail(function (error) {
                var errorText = JSON.parse(error.responseText);
                //console.log(errorText);
                dropdowncart();
                $("#cart_drawer").addClass("active");
              })
              .then(function () {
                //console.log("in then");
                $(".modal--quickshop-slim .modal-close").trigger("click");
                dropdowncart();
                $("#cart_drawer").addClass("active");
              });
            e.preventDefault();
            e.stopPropagation();
          } else {
            //console.log("Product does not have any variants");
          }
        }
      );
    });

    // Issue No 18
    $(document).on("click", "#backToLoginButton,.edit-phone", function (e) {
      $("#loginError").text("");
    });
    //     $('#getOTPButton').click();
    //   }
    // });

    // Issue No 24
    $(".profile-edit").click(function () {
      $(".but.profile").click();
      $(".flits-profile-edit-button").click();
    });

    // Issue No 26
    const alphaOnly = document.querySelectorAll(
      "#AddressFirstNameNew,#AddressLastNameNew,#AddressCompanyNew,#AddressCityNew"
    );
    alphaOnly.forEach(function (element) {
      element.addEventListener("beforeinput", function (event) {
        if (event.inputType === "deleteContentBackward") {
          return;
        }
        var value = this.value;
        if (
          !/^[a-zA-Z ]$/.test(event.data) ||
          (event.data === " " && value.length === 0)
        ) {
          event.preventDefault();
        }
      });
    });

    const numericOnly = document.querySelectorAll(
      "#AddressZipNew,AddressPhoneNew"
    );
    numericOnly.forEach(function (element) {
      element.addEventListener("beforeinput", function (event) {
        // Check if the input is the backspace key
        if (event.inputType === "deleteContentBackward") {
          // If it is, allow the input
          return;
        }

        // Check if the input is not a number
        if (!/^\d$/.test(event.data)) {
          // If it's not allowed, cancel the input event
          event.preventDefault();
        }
      });
    });

    $(".flits-address-add-save-button").click(function (e) {
      var acc_FirstName = $("#AddressFirstNameNew").val();
      var acc_LastName = $("#AddressLastNameNew").val();
      var acc_Address_New1 = $("#AddressAddress1New").val();
      var acc_Address_New2 = $("#AddressAddress2New").val();
      var acc_Company = $("#AddressCompanyNew").val();
      var acc_Zip = $("#AddressZipNew").val();
      var acc_Phone = $("#AddressPhoneNew").val();
      var acc_City = $("#AddressCityNew").val();

      if (
        acc_FirstName &&
        acc_LastName &&
        acc_Address_New1 &&
        acc_Address_New2 &&
        acc_Company &&
        acc_Zip &&
        acc_Phone &&
        acc_City
      ) {
        $(".error").remove();
        //console.log("All details are filled");
      } else {
        //console.log("All details are not filled");
        $(".error").remove();
        $("#address_form_new").append(
          '<p class="error" style="font-size: 14px;color: red!important;font-weight: 600;letter-spacing: 0.5px!important;">Please enter all the details.</p>'
        );
        return false;
      }
    });

    $("#flits-form-profile").submit(function (e) {
      e.preventDefault();
    });

    $(document).on(
      "change",
      '#flits-form-profile .flits-input[name="birthdate"]',
      function (e) {
        var birth_date = $(this).val();
        var min_birth_date = $(this).attr("min");
        var max_birth_date = $(this).attr("max");
        //console.log(birth_date, min_birth_date, max_birth_date);
        if (birth_date < min_birth_date || birth_date > max_birth_date) {
          console.error("Birth date is not within the valid range.");
          $(".error").remove();
          //$("#flits-form-profile").append('<p class="error" style="font-size: 14px;color: red!important;font-weight: 600;letter-spacing: 0.5px!important;">Please enter a valid date within the range of ' + min_birth_date + ' and ' + max_birth_date + '.</p>');
          $("#flits-form-profile").append(
            '<p class="error" style="font-size: 14px;color: red!important;font-weight: 600;letter-spacing: 0.5px!important;margin-top: 20px">Please enter a valid date.</p>'
          );
          $(".flits-profile-save-button").prop("disabled", true);
          return false;
        } else {
          // Continue with form submission or other action
          $(".flits-profile-save-button").prop("disabled", false);
          $(".error").remove();
        }
      }
    );

    $("#scan_order").click(function () {
      var track_data = $("#order_tracking_data").val();
      var track_mail = $("#email_tracking_data").val();

      if (track_data && track_mail) {
        $(".error").remove();
      } else {
        $(".error").remove();
        $(".shipway_div").append(
          '<p class="error" style="font-size: 14px;color: red!important;font-weight: 600;letter-spacing: 0.5px!important;margin-top: 20px">Please enter all the details.</p>'
        );
      }
    });
  });
}.call(window, window.jQuery);
